import React from "react";
import { useTranslation } from "react-i18next";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@shadcn-in-nx/ui/select";

const BATCH_OPTIONS = [
    { value: "10", label: "10" },
    { value: "20", label: "20" },
    { value: "100", label: "100" },
];

export default function BatchSizeSelector({ value, onChange }) {
    const { t } = useTranslation();

    return (
        <div className="flex items-center gap-2">
            <span className="text-sm text-muted-foreground whitespace-nowrap">
                {t("adminDataMigration.batchSize")}:
            </span>
            <Select value={String(value)} onValueChange={(v) => onChange(Number(v))}>
                <SelectTrigger className="w-20 h-9">
                    <SelectValue />
                </SelectTrigger>
                <SelectContent>
                    {BATCH_OPTIONS.map((opt) => (
                        <SelectItem key={opt.value} value={opt.value}>{opt.label}</SelectItem>
                    ))}
                </SelectContent>
            </Select>
        </div>
    );
}
